<div class="pagenotfound_container">
  <div class="pagenotfound_wrapper">
  <div class="logo_wrapper">
    <a class="logo">
      <img src="assets/images/logo.svg" alt="LOGO" class="logo" height="60px" />
    </a>
  </div>
  <div class="maincontent">
   <div class="maincontent__left">
     <img src="assets/images/pagenotFound.png" alt="Not Found Image" class="maincontent__left__image" height=""/>
   </div>
   <div class="maincontent__right">
     <h3>We couldn't find the page..</h3>
     <h4>You may have mistyped the address or the page may have moved.</h4>
     <div class="action">
      <a href="https://help.kinnect.us/contacts" target="_blank" style=" color:black;text-decoration: none;">
      <button
        type="submit"
        class="warning"
        style="width: 121px;height:32px;font-family: Open Sans;font-weight: bold;font-size: 12px;line-height: 16px;text-transform: uppercase;color: #FFFFFF;"
      >
      Contact Us
      </button></a>

      <button
        type="submit"
        class="info"
        style="width: 121px;height:32px;font-family: Open Sans;font-weight: bold;font-size: 12px;line-height: 16px;text-transform: uppercase;color: #FFFFFF;margin-left: 20px;"
       (click)="gotoHome()"
        >
        Home
      </button>
    </div>
   </div>
  </div>
  </div>
  <img class="polygon" src="../../../assets/images/home-polygon.png" alt="" />
  <img class="half-polygon" src="../../../assets/images/half-polygon-bg.png" alt="" />
</div>